import { FunctionComponent, useContext, useState } from "react";
import { IWebhook } from "../../../../interfaces/common/webhooks";
import { Alert, Button, CircularProgress, FormControl, TextField } from "@mui/material";
import { emptyWebhook } from "../../../../data/webhooks";
import { API_ENDPOINT } from "../../../../configurations/global.config";
import axios, { AxiosResponse, isAxiosError } from "axios";
import { AuthContext } from "../../../../contexts/user-context/user-context";
import { useSnackBar } from "../../../../contexts/snackbar";
import { ErrorsFlattenner } from "../../../common/errors-flattenner/errors-flattenner";

interface WebhookFormProps {
    onSuccess: (w: IWebhook) => void
    defaultWebhook: IWebhook
}

const WebhookForm: FunctionComponent<WebhookFormProps> = ({ defaultWebhook, onSuccess }) => {
    const [webhook, setWebhook] = useState<IWebhook>(defaultWebhook);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { config } = useContext(AuthContext);
    const [response, setResponse] = useState<AxiosResponse>()
    const { showMessage } = useSnackBar()

    const handleSubmit = async () => {
        setIsLoading(true)
        setResponse(undefined)
        try {
            let endpoint = `${API_ENDPOINT}/v1/webhooks/`
            let response;

            const isNewWebhook = webhook.id <= 0;

            if (!isNewWebhook) {
                endpoint += `${webhook.id.toString()}/`
                response = await axios.put<IWebhook>(endpoint, webhook, config)
            } else {
                response = await axios.post<IWebhook>(endpoint, webhook, config)

                // If webhook was just created and secret is returned, download it
                downloadSecretFile(response.data.secret, response.data.name);
            }

            onSuccess(response.data)
        } catch (e) {
            if (isAxiosError(e)) setResponse(e.response)
            showMessage("Failed to save webhook", 'error')
        } finally {
            setIsLoading(false)
        }
    }

    const downloadSecretFile = (secret: string, webhookName: string) => {
        const fileContent = `Webhook: ${webhookName}\nSecret: ${secret}`;
        const blob = new Blob([fileContent], { type: 'text/plain' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${webhookName}_secret.txt`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }

    return <div>
        {response && response.status >= 300 && (
            <Alert sx={{ mb: 4 }} severity="error" >
                Failed to save webhook
                <ErrorsFlattenner rawErrors={response.data} />
            </Alert>
        )}

        {isLoading && <div style={{ margin: 4, width: "100%", textAlign: "center" }}><CircularProgress /></div>}
        <form style={{ padding: 2, margin: 4 }} onSubmit={(e) => { e.preventDefault(); handleSubmit() }}>
            <FormControl fullWidth>
                <TextField
                    disabled={isLoading}
                    label="Unique Name"
                    placeholder="Unique webhook name"
                    value={webhook.name}
                    autoComplete="new-password"
                    required
                    onChange={(e) => setWebhook({ ...webhook, name: e.target.value })}
                />
            </FormControl>
            <br />
            <br />
            <FormControl fullWidth>
                <TextField
                    disabled={isLoading}
                    label="Webhook's endpoint"
                    type="url"
                    required
                    placeholder="Endpoint"
                    value={webhook.endpoint}
                    autoComplete="new-password"
                    onChange={(e) => setWebhook({ ...webhook, endpoint: e.target.value })}
                />
            </FormControl>

            <br />
            <br />
            <div style={{ width: "100%", textAlign: "center" }}>
                <Button variant="contained" type="submit">Save</Button>
            </div>
        </form>
    </div>
}

export default WebhookForm;
